import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Logo } from "./Logo";

function FullLoader() {
  return (
    <div className="grid min-h-screen place-items-center bg-ink">
      <div className="animate-pulse">
        <Logo size={48} />
      </div>
    </div>
  );
}

export function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === undefined) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    const home = user.role === "admin" ? "/admin" : "/app";
    return <Navigate to={home} replace />;
  }
  return children;
}

export { FullLoader };
